import { Box, TextField, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { ContainedButtonWithIcon } from "../buttonCompo/Buttons";
import { AddIcon, SearchIcon } from "../Icons";

const Topbar = ({ onSearch }) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const handleAddPharmacyEmployeeClick = () => {
    navigate("/addemployee/add-info");
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    onSearch(query); // Trigger the parent component's search function
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <TextField
        value={searchQuery}
        onChange={handleSearchChange} // Call the handler on change
        variant="outlined"
        autoComplete="off"
        placeholder="Search"
        InputProps={{
          sx: {
            fontSize: "11px",
            border: "1px solid #dce0e4",
          },
          startAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        sx={{
          width: 408,
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            height: "36px",
            paddingLeft: 0,
            "& fieldset": {
              border: "none",
            },
          },
        }}
        size="small"
      />
      <ContainedButtonWithIcon
        label="Add Employee"
        icon={<AddIcon />}
        borderRadius="8px"
        width="150px"
        fontSize="13px"
        padding="4px"
        onClick={handleAddPharmacyEmployeeClick}
      />
    </Box>
  );
};

export default Topbar;
